import { format } from 'date-fns';
import { ru, enUS } from 'date-fns/locale';
import type {
  Language,
  OperationsListResponseDto,
  OperationStatusIcon,
  OperationTypeIcon,
} from '@/shared/types';
import { Card } from '@/shared/components';
import { OperationsHistoryItem } from '@/entities/operation';
import type { OperationDto } from '@/shared/types';
import { useGroupOperationsByDate } from '@/shared/lib';

type Props = {
  data: OperationsListResponseDto;
  language: Language;
  operationTypeIcons: OperationTypeIcon[];
  operationStatusIcons: OperationStatusIcon[];
  onOperationItemClick?: (operation: OperationDto) => void;
};

export const HistoryOperationsList = ({
  data,
  language,
  operationTypeIcons,
  operationStatusIcons,
  onOperationItemClick,
}: Props) => {
  const { operations } = data;

  const locale = language === 'ru' ? ru : enUS;

  const { groupedOperations } = useGroupOperationsByDate(operations);

  return (
    <div className="flex flex-col gap-[2.4rem]">
      {Object.entries(groupedOperations).map(([monthYear, operations]) => {
        const title = format(new Date(`${monthYear}-01`), 'LLLL yyyy', {
          locale,
        });

        return (
          <div className={'flex flex-col gap-[1.6rem]'} key={monthYear}>
            <h1 className="ml-[1.6rem] headline4 text-primary capitalize">
              {title}
            </h1>

            <Card className="w-full py-[1.6rem] px-[1.2rem] flex flex-col rounded-[2.4rem] gap-0 mb-0">
              {operations.map(operation => (
                <OperationsHistoryItem
                  key={operation.operaionid}
                  operation={operation}
                  operationStatusIcons={operationStatusIcons}
                  operationTypeIcons={operationTypeIcons}
                  onOperationItemClick={onOperationItemClick}
                />
              ))}
            </Card>
          </div>
        );
      })}
    </div>
  );
};
